import {
  GET_DIAMETER_LIST,
  GET_DIAMETER_LIST_PENDING,
  GET_DIAMETER_LIST_FULFILLED,
  DiameterActionTypes,
  DiameterState,
} from './diameter.types';

export const initialState: DiameterState = {
  entities: [],
};

export default function DeliveryFunctionNetworkInterfaceReducer(
  state = initialState,
  action: DiameterActionTypes,
): DiameterState {
  switch (action.type) {
    case GET_DIAMETER_LIST:
      return {
        ...state,
      };

    case GET_DIAMETER_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
      };

    case GET_DIAMETER_LIST_PENDING:
      return {
        ...state,
      };

      default:
      return state;
  }
}
